import React from 'react';
import { Box, styled } from '@mui/material';
import MonthlyEntries from '../../components/MonthlyEntries';
import CurrentHourEntries from '../../components/CurrentHourEntries';
import LoadingPage from '../loading/LoadingPage';
import HourlyEntries from '../../components/HourlyEntries';
import DailyEntries from '../../components/DailyEntries';
import { DashboardProvider, useDashboard } from '../../context/DashboardContext';

const Wrapper = styled(Box)`
    flex-grow: 1;
    height: 100%;
    width: 100%;
    ${({ theme }) => theme.breakpoints.up('md')} {
        max-width: 1700px;
    }
`;

const GridContainer = styled(Box)`
    display: grid;
    gap: ${({ theme }) => theme.spacing(2)};
    grid-template-columns: 1fr;
    margin-bottom: ${({ theme }) => theme.spacing(3)};
    ${({ theme }) => theme.breakpoints.up('md')} {
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        height: 100%;
    }
`;

function DashboardContent() {
    const { loading, data } = useDashboard();

    if (loading) return <LoadingPage />;

    if (!data) return null;

    return (
        <Wrapper>
            <GridContainer>
                <HourlyEntries
                    entriesPerHourXValues={data.charts.entriesPerHour.xValues}
                    entriesPerHourYValues={data.charts.entriesPerHour.yValues}
                />
                <CurrentHourEntries
                    data={{
                        lastHour: data.lastHour,
                        newCustomersTodayPercentage: data.newCustomersTodayPercentage,
                        charts: data.charts,
                        checkedinStaff: data.checkedinStaff,
                    }}
                />
                <DailyEntries
                    entriesPerDayXValues={data.charts.entriesPerDay.xValues}
                    entriesPerDayYValues={data.charts.entriesPerDay.yValues}
                />
                <MonthlyEntries charts={data.charts} />
            </GridContainer>
        </Wrapper>
    );
}

function Dashboard() {
    return (
        <DashboardProvider>
            <DashboardContent />
        </DashboardProvider>
    );
}

export default Dashboard;
